(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-how-it-works';

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var wrapper = section.querySelector('.oddit-section-how-it-works__steps-wrapper');
    var steps = section.querySelectorAll('.oddit-section-how-it-works__step');
    var dots = section.querySelectorAll('.oddit-section-how-it-works__dot');
    var prevBtn = section.querySelector('.oddit-section-how-it-works__nav-btn--prev');
    var nextBtn = section.querySelector('.oddit-section-how-it-works__nav-btn--next');

    if (!wrapper || !steps.length) return;

    var currentIndex = 0;

    function setActive(index) {
      if (index < 0) index = 0;
      if (index >= steps.length) index = steps.length - 1;
      currentIndex = index;

      for (var i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('oddit-section-how-it-works__dot--active');
          dots[i].setAttribute('aria-selected', 'true');
        } else {
          dots[i].classList.remove('oddit-section-how-it-works__dot--active');
          dots[i].setAttribute('aria-selected', 'false');
        }
      }

      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === steps.length - 1;
    }

    function scrollToIndex(index) {
      if (index < 0 || index >= steps.length) return;
      var target = steps[index];
      if (!target) return;

      var wrapperRect = wrapper.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var scrollOffset = wrapper.scrollLeft + (targetRect.left - wrapperRect.left);

      wrapper.scrollTo({
        left: scrollOffset,
        behavior: 'smooth'
      });
    }

    function handleDotClick(e) {
      var idx = parseInt(e.currentTarget.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      scrollToIndex(idx);
      setActive(idx);
    }

    function handlePrev() {
      var newIndex = currentIndex - 1;
      if (newIndex < 0) return;
      scrollToIndex(newIndex);
      setActive(newIndex);
    }

    function handleNext() {
      var newIndex = currentIndex + 1;
      if (newIndex >= steps.length) return;
      scrollToIndex(newIndex);
      setActive(newIndex);
    }

    function handleScroll() {
      var wrapperRect = wrapper.getBoundingClientRect();
      var wrapperCenter = wrapperRect.left + wrapperRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      for (var i = 0; i < steps.length; i++) {
        var rect = steps[i].getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var distance = Math.abs(center - wrapperCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      }

      if (closestIndex !== currentIndex) {
        setActive(closestIndex);
      }
    }

    var scrollRaf = null;
    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        handleScroll();
        scrollRaf = null;
      });
    }

    for (var i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', handleDotClick);
    }

    if (prevBtn) prevBtn.addEventListener('click', handlePrev);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);
    wrapper.addEventListener('scroll', onScroll, { passive: true });

    setActive(0);
  }

  function destroySection(section) {
    if (!section) return;
    section.dataset.odditInit = '';
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();